import { render, staticRenderFns } from "./update-profile.vue?vue&type=template&id=ea0f9508&"
import script from "./update-profile.vue?vue&type=script&lang=js&"
export * from "./update-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports